import type { CommitImportResult, ImportDto } from '@pb/shared';
import { get, post, uploadFile } from './client';

export interface CommitImportInput {
  units: { pages: number[]; title?: string }[];
  new_groups: { name: string; description?: string; units: number[] }[];
  append_to_groups: { group_id: number; units: number[] }[];
  tag_ids?: number[];
}

export const startImport = (projectId: number, file: File, onProgress: (fraction: number) => void) =>
  uploadFile<ImportDto>(`/projects/${projectId}/imports`, file, { filename: file.name }, onProgress);
export const getImport = (id: number) => get<ImportDto>(`/imports/${id}`);
export const commitImport = (id: number, input: CommitImportInput) =>
  post<CommitImportResult>(`/imports/${id}/commit`, input);
export const discardImport = (id: number, confirm: string) => post<unknown>(`/imports/${id}/discard`, { confirm });
